import { createSelector } from 'reselect';
import { RootState } from '../redux';

export const selectConversionRates = ({ conversionRates: { rates } }: RootState) => rates;

export const selectConversionRatesByEntity = (entityId: number | undefined) =>
  createSelector(selectConversionRates, (rates) =>
    rates === null ? null : rates.filter(({ legalEntity }) => legalEntity.entityId === entityId)
  );
